var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'ss__custom__header__menu__wrapper',
    {'ss__custom__header__menu__wrapper--visible': _vm.visible}
  ]},[_c('SsButton2',{staticClass:"ss__custom__header__menu__btn__toogle",attrs:{"type":"text"},on:{"click":_vm.toggleVisible}},[_c('transition',{attrs:{"name":"btn__fade","mode":"out-in"}},[(!_vm.visible)?_c('i',{key:"menu",staticClass:"ssCommunityIcon__menu"}):_c('i',{key:"cancel",staticClass:"ssCommunityIcon__cancel"})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }